var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner"},[_c('img',{attrs:{"src":require('@images/shared/spinner.gif')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }